import { useState } from 'react';
import axiosInstance from '../Services/Api'; // Adjust the import path

const CheckoutModal = ({ setCheckoutModalOpen,productId,getCheckout }) => {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            if (!name.trim()) {
                setError('Por favor, insira um nome válido');
                return;
            }

            const response = await axiosInstance.post('/checkout/create', {
                name: name.trim(),
                productId:productId
            });

            if (response.data.success) {
                setCheckoutModalOpen(false);
                getCheckout(productId);
            }
        } catch (error) {
            console.error('Error creating checkout:', error);
            setError(error.response?.data?.message || 'Erro ao criar checkout');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[99999] flex items-center justify-center ">
            <div className="bg-[#1D1D1D] rounded-lg shadow-lg md:min-w-[600px] w-[80%] md:w-full max-w-md p-6 px-0">
                <div className="flex w-full justify-between px-4">
                    <h2 className="px-4 text-[18px] font-bold mb-2">Criar novo checkout</h2>
                    <p onClick={() => setCheckoutModalOpen(false)} className="cursor-pointer">x</p>
                </div>
                <div className="w-full border border-[gray]"></div>
                <div className="px-4 mt-4">
                    {error && <div className="text-red-500 text-sm mb-4">{error}</div>}
                    <div className="flex gap-4 w-full">
                        <div className="flex w-full flex-col">
                            <label className="text-[12px] text-[#AEB9E1] my-1">Nome</label>
                            <input 
                                className="bg-[#313131] rounded-[8px] p-1 px-2"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                disabled={loading}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-1 mt-4 px-4">
                    <button 
                        className={`px-4 py-2 bg-[#478DF8] text-white rounded-[8px] ${
                            loading ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? 'Criando...' : 'Confirmar'}
                    </button>
                    <button 
                        onClick={() => setCheckoutModalOpen(false)}
                        className="px-4 py-2 text-white text-[12px] underline rounded"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CheckoutModal;